var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTweetGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.087,
    height: 17.997,
    viewBox: "0 0 22.087 17.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.415,
    y1: 0.061,
    x2: 7.233,
    y2: 3.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b998e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#27a486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#46b07c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#5db975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#6abe71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc070"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M75.108,98.365a9.816,9.816,0,0,1-1.265.622,11.58,11.58,0,0,1-1.308.418.487.487,0,0,1-.525-.139,4.354,4.354,0,0,0-4.492-1,4.493,4.493,0,0,0-3.056,5.179c.021.139.011.172-.139.161a15.327,15.327,0,0,1-2.2-.332A12.865,12.865,0,0,1,55.4,99.2a1.332,1.332,0,0,0-.289-.311,4.548,4.548,0,0,0,1.4,6.036c-.182-.011-.289-.021-.407-.032a4.3,4.3,0,0,1-1.48-.45c-.107-.064-.172-.086-.161.1a4.546,4.546,0,0,0,3.613,4.332,4.745,4.745,0,0,1-2.016.086A4.55,4.55,0,0,0,60.3,112.1a9.237,9.237,0,0,1-6.7,1.887,12.8,12.8,0,0,0,5.2,1.908,13.276,13.276,0,0,0,4.868-.225,12.129,12.129,0,0,0,7.387-5.039,13.105,13.105,0,0,0,2.412-7.955.31.31,0,0,1,.139-.289,9.008,9.008,0,0,0,1.029-.89c.129-.129.257-.279.375-.418s.247-.289.354-.429.214-.289.322-.44a9.651,9.651,0,0,1-2.477.622A4.662,4.662,0,0,0,75.108,98.365Z",
    transform: "translate(-53.6 -98.024)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweetGreen);
export default __webpack_public_path__ + "static/media/tweetGreen.7428e4e00acbf305643be2a603aa50a9.svg";
export { ForwardRef as ReactComponent };